    import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { emptyCategory, Category } from "../../../../interfaces/category";
import { useEffect, useState } from "react";
import { deleteCategory, getCategoriesSingle } from "../../../../services/category";
import { Trans } from "react-i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminCategoryDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminCategoryDelete(props: AdminCategoryDeleteProps) {
    const [category, setCategory] = useState<Category>(emptyCategory);

    const handleDelete = () => {
        deleteCategory(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Category cannot be deleted. Teams of this category exist."));
                    props.onClose();
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getCategoriesSingle(props.id)
            .then(response => {
                setCategory(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-category-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_category") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { category.id == 0 && 
                    <LoadingSpinner />
                }
                { category.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_category_message"
                                values={{
                                    category_name: category.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
